import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { JourneyListRow } from "./types";

// GET /api/admin/journeys[?archived=1] → { journeys: JourneyListRow[] }
//
// Sub-bucket 14. The admin list page consumes this directly. Archived rows
// are excluded server-side by default; the active/archived toggle re-keys the
// query so both views cache independently. The list is small (sub-100 rows in
// practice) so we don't page or virtualize.
export function useJourneys(options: { includeArchived?: boolean } = {}) {
  const includeArchived = Boolean(options.includeArchived);
  return useQuery<JourneyListRow[], ApiClientError>({
    queryKey: [...queryKeys.journeys.list(), includeArchived],
    queryFn: async () => {
      const qs = includeArchived ? "?archived=1" : "";
      const body = await apiFetch<{ journeys: JourneyListRow[] }>(
        `/admin/journeys${qs}`,
      );
      return body.journeys;
    },
  });
}
